import Button from '../ui/Button'

const CREDENTIALS = [
  'Patent-pending distributed inference engine',
  'Private by design',
  'Predictable capacity',
  'Production SLAs',
]

export default function Hero({ liquidBackground }) {
  return (
    <section className="relative -mt-[94px] flex min-h-screen flex-col justify-center overflow-hidden bg-[#050607] pt-[140px] pb-20 sm:pt-[190px]">
      {liquidBackground}
      <div className="relative z-[1] max-w-none pr-7 pl-[calc(max(0px,_(100%_-_1080px)/2)_+_28px)]">
        {/* The brand line sits here rather than in a headline tier: it makes the
            same promise as "Unlimited tokens. Unlimited context." but vaguer, so
            it earns a label, not a display size. */}
        <span className="flex items-baseline gap-2.5 font-mono text-[12px] leading-[1.6] tracking-[0.14em] uppercase">
          <span aria-hidden="true" className="h-[6px] w-[6px] flex-none translate-y-[-2px] rounded-full bg-[#5B8CFF]" />
          <span className="text-[#5B8CFF]">AI without limits</span>
        </span>

        <h1 className="mt-9 max-w-[15ch] text-[clamp(2.7rem,5.6vw,4.5rem)] leading-[0.98] font-semibold tracking-[-0.045em] text-[#F5F5F3]">
          Unlimited tokens. Unlimited context.
        </h1>

        <p className="mt-8 max-w-[26ch] text-[clamp(1.35rem,2.4vw,1.8rem)] leading-[1.25] tracking-[-0.022em] text-[#F5F5F3]">
          Run the AI your business actually wants to run.
        </p>

        <p className="mt-8 max-w-[560px] text-[1.05rem] leading-[1.68] text-[rgba(245,245,243,.72)]">
          Tell LiquidBrain what the workload needs to accomplish. LiquidBrain determines how to execute it across
          models, memory, compute, and infrastructure.
        </p>

        <div className="mt-11 flex flex-wrap items-center gap-3.5">
          <Button tone="dark" variant="primary" href="#" data-reserve>
            Bring us your workload &rarr;
          </Button>
          <Button tone="dark" variant="ghost" href="#benchmark">
            See the benchmark &rarr;
          </Button>
        </div>

        <p className="mt-9 max-w-[640px] font-mono text-[11.5px] leading-[2] tracking-[0.12em] text-[rgba(245,245,243,.5)] uppercase">
          {CREDENTIALS.join('\u00a0· ')}
        </p>
      </div>
    </section>
  )
}
